import React from 'react';
import './navbar.css';

const Navbar = ({ scrollToContact }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="BluBlu Logo" className="logo" />
      </div>
      <div className="navbar-right">
        <a href="/#" className="nav-link" onClick={scrollToTop}>Home</a>
        <a href="/#contact" className="nav-link contact" onClick={scrollToContact}>Contact</a>
      </div>
    </nav>
  );
};

export default Navbar; 